const STATUS_SNAPSHOT_MAX_AGE_MS = 5 * 60 * 1000;

interface StatusSnapshot<T> {
  storedAt: number;
  data: T;
}

export function readStatusSnapshot<T>(key: string): T | undefined {
  try {
    const snapshot = localStorage.getItem(key);
    if (!snapshot) return undefined;

    const parsed = JSON.parse(snapshot) as StatusSnapshot<T>;
    if (!parsed?.storedAt || Date.now() - parsed.storedAt > STATUS_SNAPSHOT_MAX_AGE_MS) {
      localStorage.removeItem(key);
      return undefined;
    }

    return parsed.data;
  } catch {
    localStorage.removeItem(key);
    return undefined;
  }
}

export function writeStatusSnapshot<T>(key: string, data: T): void {
  try {
    localStorage.setItem(key, JSON.stringify({ storedAt: Date.now(), data }));
  } catch {
    // Ignore storage quota/private-mode failures; live API data remains authoritative.
  }
}
